<template>
    <div class="portal-page" :style="`direction:${lang.dir}`">
        <div class="portal-page__header">
            <div class="portal-brand">
                <i class="mdi mdi-car-wrench"></i>
            </div>
            <h1>{{ isEn ? 'Spare Part Approval' : 'موافقة على قطعة غيار' }}</h1>
        </div>

        <div class="portal-page__body">
            <div v-if="loading" class="portal-card portal-block">
                <p class="portal-loading">{{ isEn ? 'Loading...' : 'جاري التحميل...' }}</p>
            </div>

            <div v-else-if="errorCode" class="portal-card portal-block">
                <div class="portal-message error">{{ describe(errorCode) }}</div>
            </div>

            <div v-else-if="decided" class="portal-card portal-block">
                <div class="portal-message success">{{ decidedMessage }}</div>
            </div>

            <div v-else class="portal-card portal-block">
                <h2>{{ info.item_name }}</h2>
                <div class="portal-approve-row">
                    <span class="portal-block__label">{{ isEn ? 'Job Card #' : 'رقم أمر العمل' }}</span>
                    <strong>{{ info.job_card_number }}</strong>
                </div>
                <div class="portal-approve-row">
                    <span class="portal-block__label">{{ isEn ? 'Quantity' : 'الكمية' }}</span>
                    <strong>{{ info.quantity }}</strong>
                </div>
                <div class="portal-approve-row">
                    <span class="portal-block__label">{{ isEn ? 'Price' : 'السعر' }}</span>
                    <strong class="portal-approve-price">{{ info.price }} {{ isEn ? 'SAR' : 'ريال' }}</strong>
                </div>

                <p v-if="info.is_essential" class="portal-approve-note">
                    {{ isEn
                        ? 'This part is required to finish the job. You can approve the price or provide the part yourself.'
                        : 'هذه القطعة ضرورية لإتمام العمل. يمكنكم الموافقة على السعر أو توفير القطعة بأنفسكم.' }}
                </p>
                <p v-else class="portal-approve-note">
                    {{ isEn
                        ? 'This part is not covered by your agreement. Please choose how you would like to proceed.'
                        : 'هذه القطعة غير مشمولة بالاتفاقية. يرجى اختيار الطريقة التي تفضلونها.' }}
                </p>

                <div v-if="message" class="portal-message error">{{ message }}</div>

                <b-button variant="primary" block class="mt-3" :disabled="busy" @click="submitDecision('approved')">
                    {{ isEn ? 'Approve the price' : 'الموافقة على السعر' }}
                </b-button>
                <b-button variant="outline-primary" block class="mt-2" :disabled="busy" @click="submitDecision('will_provide')">
                    {{ isEn ? "I'll bring my own part" : 'سأقوم بتوفير القطعة بنفسي' }}
                </b-button>
                <b-button v-if="!info.is_essential" variant="link" block :disabled="busy" @click="submitDecision('declined')">
                    {{ isEn ? 'Decline' : 'رفض الطلب' }}
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'PortalApprovePart',
    data() {
        return {
            token: '',
            loading: true,
            errorCode: '',
            busy: false,
            message: '',
            decided: false,
            decidedMessage: '',
            info: { item_name: '', quantity: 0, price: 0, is_essential: false, job_card_number: '' },
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki) == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki) == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        isEn(){
            return this.lang.langname === 'en';
        },
    },
    created() {
        this.token = (this.$route.query.token || '').toString();
        this.loadApproval();
    },
    methods: {
        describe(code){
            const en = {
                invalid_token: 'This link is invalid or has expired.',
                already_decided: 'A decision has already been recorded for this request.',
                essential_cannot_decline: 'This part is required to finish the job and cannot be declined outright.',
            };
            const ar = {
                invalid_token: 'هذا الرابط غير صالح أو منتهي الصلاحية.',
                already_decided: 'تم تسجيل قرار لهذا الطلب مسبقاً.',
                essential_cannot_decline: 'هذه القطعة ضرورية لإتمام العمل ولا يمكن رفضها بالكامل.',
            };
            const dict = this.isEn ? en : ar;
            return dict[code] || (this.isEn ? 'Something went wrong.' : 'حدث خطأ ما.');
        },
        post(type, extra = {}){
            const data = new FormData();
            data.append('type', type);
            Object.keys(extra).forEach((k) => data.append(`data[${k}]`, extra[k]));
            return axios.post(this.$store.state.SAMCOTEC.r_path, data).then((res) => res.data);
        },
        loadApproval(){
            if(!this.token){
                this.loading = false;
                this.errorCode = 'invalid_token';
                return;
            }
            this.post('getSparePartApproval', { token: this.token }).then((res) => {
                this.loading = false;
                if(res && res.error && res.error.number === 200){
                    this.info = res.results;
                }else{
                    this.errorCode = (res && res.error && res.error.message) || 'invalid_token';
                }
            }).catch(() => {
                this.loading = false;
                this.errorCode = 'invalid_token';
            });
        },
        submitDecision(decision){
            if(decision === 'declined'){
                const confirmText = this.isEn ? 'Are you sure you want to decline this request?' : 'هل أنتم متأكدون من رفض هذا الطلب؟';
                if(!window.confirm(confirmText)) return;
            }
            this.busy = true;
            this.message = '';
            this.post('decideSparePartApproval', { token: this.token, decision }).then((res) => {
                this.busy = false;
                if(res && res.error && res.error.number === 200){
                    const messages = {
                        approved: this.isEn ? 'Thank you, you approved the price. We will proceed with the work.' : 'شكراً لكم، تمت الموافقة على السعر. سنستكمل العمل.',
                        will_provide: this.isEn ? 'Noted, we will wait for you to bring the part.' : 'تم التسجيل، بانتظار توفيركم للقطعة.',
                        declined: this.isEn ? 'Your decision has been recorded.' : 'تم تسجيل قراركم.',
                    };
                    this.decided = true;
                    this.decidedMessage = messages[decision] || (this.isEn ? 'Recorded.' : 'تم التسجيل.');
                }else{
                    this.message = this.describe((res && res.error && res.error.message) || '');
                }
            }).catch(() => {
                this.busy = false;
                this.message = this.isEn ? 'Could not submit your decision, please try again.' : 'تعذر إرسال قراركم، الرجاء المحاولة مرة أخرى.';
            });
        },
    },
}
</script>

<style scoped>
.portal-page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}
.portal-page__header {
    padding: 40px 24px 28px;
    background: linear-gradient(160deg, var(--portal-ink) 0%, #1e3247 100%);
    color: #fff;
    text-align: center;
    border-radius: 0 0 28px 28px;
}
.portal-brand {
    width: 56px;
    height: 56px;
    margin: 0 auto 14px;
    border-radius: 16px;
    background: var(--portal-accent);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 18px -6px rgba(221, 126, 31, .55);
}
.portal-brand .mdi {
    font-size: 30px;
    color: var(--portal-accent-ink);
}
.portal-page__header h1 {
    font-size: 1.2rem;
    font-weight: 700;
    margin: 0;
}
.portal-page__body {
    flex: 1;
    padding: 20px 18px 28px;
}
.portal-card {
    background: var(--portal-surface);
    border: 1px solid var(--portal-border);
    border-radius: var(--portal-radius-lg);
    box-shadow: var(--portal-shadow);
    padding: 18px 16px;
}
.portal-block h2 {
    font-size: 1.05rem;
    font-weight: 700;
    margin: 0 0 14px;
    color: var(--portal-ink);
}
.portal-block__label {
    font-size: .78rem;
    font-weight: 600;
    color: var(--portal-ink-muted);
}
.portal-approve-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid var(--portal-border);
}
.portal-approve-row:last-of-type { border-bottom: none; }
.portal-approve-price {
    color: var(--portal-accent-dark);
    font-size: 1.1rem;
}
.portal-approve-note {
    margin: 14px 0 4px;
    font-size: .85rem;
    color: var(--portal-ink-muted);
}
.portal-loading {
    text-align: center;
    color: var(--portal-ink-muted);
    margin: 0;
}
.portal-message {
    display: flex;
    align-items: center;
    margin-top: 10px;
    padding: 10px 12px;
    border-radius: var(--portal-radius-md);
    font-size: .85rem;
}
.portal-message.error {
    background: var(--portal-bad-soft);
    color: var(--portal-bad);
}
.portal-message.success {
    background: var(--portal-good-soft);
    color: var(--portal-good);
}
.portal-block >>> .btn-primary {
    background: var(--portal-accent) !important;
    border-color: var(--portal-accent) !important;
    color: var(--portal-accent-ink) !important;
    font-weight: 700;
    border-radius: var(--portal-radius-md) !important;
    padding: 11px !important;
}
.portal-block >>> .btn-primary:disabled {
    opacity: .55;
}
.portal-block >>> .btn-outline-primary {
    color: var(--portal-accent-dark) !important;
    border-color: var(--portal-accent) !important;
    border-radius: var(--portal-radius-md) !important;
    font-weight: 700;
    padding: 11px !important;
}
</style>
